import React, { useRef } from 'react';
import { Tooltip } from 'primereact/tooltip';
import { classNames } from 'primereact/utils';

const TruncatedText = ({ 
  text = '', 
  maxLength = 30, 
  style = {}, 
  className = '',
  showCursor = true,
  tooltipOptions = {}
}) => {
  const textRef = useRef(null);
  const shouldTruncate = text.length > maxLength;
  const displayText = shouldTruncate 
    ? `${text.substring(0, maxLength)}...` 
    : text;

  const cursorStyle = showCursor && shouldTruncate 
    ? { cursor: 'help' } 
    : {};

  const combinedClassName = classNames(
    {
      'p-text-truncate': shouldTruncate,
      // 'p-component': true
    },
    className
  );

  return (
    <>
      <span
        ref={textRef}
        style={{ ...style, ...cursorStyle }}
        className={combinedClassName}
        data-pr-tooltip={shouldTruncate ? text : undefined}
        data-pr-position="top"
      >
        {displayText}
      </span>
      
      {shouldTruncate && textRef.current && (
        <Tooltip 
          target={textRef.current}
          content={text}
          position="top"
          showDelay={300}
          hideDelay={100}
          {...tooltipOptions}
        />
      )}
    </>
  );
};

export default TruncatedText;